<template>
    <div>
      <div id="box">
        <v-row class="row pa-2">
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <div id="title" :style="{'color':theme}">
            {{title}}
            </div>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-autocomplete
              v-model="selectedFilter.CampaignId"
              item-value="id"
              item-text="name"
              :items="filterCampaigns"
              label="Campaign Filter"
              hide-details
              outlined
              auto-select-first
              @change="search"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-autocomplete
              v-model="selectedFilter.UserId"
              item-value="id"
              item-text="name"
              :items="filterUsers"
              label="CC Filter"
              hide-details
              outlined
              auto-select-first
              @change="search"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="3" class="pb-0">
            <v-menu
              ref="monthPicker"
              v-model="monthPicker"
              :close-on-content-click="false"
              :return-value.sync="selectedMonth"
              transition="scale-transition"
              offset-y
              dense
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  label="Year Month"
                  v-model="searchMonth"
                  readonly
                  clearable
                  outlined
                  hide-details="auto"
                  v-bind="attrs"
                  v-on="on"
                  @change="search()"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="searchMonth"
                type="month"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="secondary"
                    @click="monthPicker = false"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    color="secondary"
                    @click="searchMonthOk"
                >
                    OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-divider ></v-divider>
        <v-row class="mg-top-0">
            <v-col cols="12" class="pd-top-0">
                <v-container class="pd-top-0">
                    <v-row justify="center" align="center" style="margin-top:20px;">
                        <v-col cols="12" sm="12" md="9" lg="9" >
                            <canvas id="pieChart" width="500" height="200" ></canvas>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
      </div>
    </div>

    <!-- <div>
       <v-card>
          <v-card-text>
            <v-row justify="center" align="center">
              <v-col cols="12" >
                <span style="font-size:16px;font-weight:400;padding-right:15px;">Report Abuse in %</span>
              </v-col>
            </v-row>
            <v-row justify="center" align="center" style="margin-top:20px;">
              <v-col cols="12" sm="12" md="9" lg="9" >
                <canvas id="pieChart" width="500" height="200" ></canvas>
              </v-col>
            </v-row>
          </v-card-text>
       </v-card>
    </div> -->
</template>
<script>
import Chart from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import 'chart.piecelabel.js';
export default {
  name: 'Pie-Chart',
  props: {
    theme: {type: String},
    id: {type: String},
    title: {type: String},
    filters: {type: Array},
    labels: {type: Array},
    backgroundColors: {type: Array},
    items: {type: Array},
    filterCampaigns: {type: Array},
    filterUsers: {type: Array}
  },
  data() {
    return {
      toggle_filter: 0,
      selectedFilter: {CampaignId: '', UserId: ''},
      searchMonth: '',
      selectedMonth: '',
      monthPicker: false
    }
  },
  mounted() {
    this.renderChart()
  },
  watch: {
    items() {
      this.renderChart()
    }
  },
  methods: {
    renderChart() {
      var ctx = document.getElementById('pieChart');
      const config = {
        type: 'pie',
        plugins: [ChartDataLabels],
        data: {
          'labels': this.labels,
          'datasets': [
            {
              'data': this.items,
              'backgroundColor': this.backgroundColors
            }
          ]
        },
        options: {
          responsive: true,
          legend: false,
          pieceLabel: {
            render: 'label',
            fontColor: '#000',
            position: 'outside',
            segment: true
          },
          plugins: {
            datalabels: {
              color: '#000',
              font: {
                weight: 'bold'
              },
              formatter: function(value, context) {
                return `${value}%`;
              }
            }
          }
        }
      };
      if (window.pie !== undefined) {
        window.pie.destroy()
      }
      // eslint-disable-next-line
      window.pie = new Chart(ctx, config)
    },
    search() {
      let filter = Object.assign({}, {
        CampaignId: this.selectedFilter.CampaignId,
        UserId: this.selectedFilter.UserId,
        month: this.searchMonth
      });
      this.$emit('searchfilter', filter)
    },
    searchMonthOk() {
      this.$refs.monthPicker.save(this.searchMonth);
      this.search();
    }
  }
}
</script>
<style scoped>
.mg-top-0 {
  margin-top: 0px !important;
}

.mg-bottom-0 {
  margin-bottom: 0px !important;
}

.mg-bottom-10 {
  margin-bottom: 10px !important;
}

.pd-bottom-0 {
  padding-bottom: 0px !important;
}

.pd-top-0 {
  padding-top: 0px !important;
}

.filter-pad {
    padding:10px 0 0px 10px;
}

#box {
  /* width: 366px; */
  /* min-height: 430px; */

  border: 0.8px solid #E5E5E5;
  box-sizing: border-box;
}

#title {
  /* width: 366px; */
  height: 46px;

  font-family: WorkSans-Medium;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: 45px;

  padding-left:17px;
  padding-top:5px;
}

#avg {
  padding-top:10px;
  /* height: 28px; */
  left: calc(50% - 304px/2 - 1px);
  top: calc(50% - 28px/2 - 7.5px);

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;
  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

#avgTitle {
  /* width: 309px; */
  height: 12px;
  left: calc(50% - 309px/2 - 3.5px);
  top: calc(50% - 12px/2 + 18.5px);
  padding-top:5px;

  font-family: WorkSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 12px;
/* identical to box height */

  text-align: center;
  letter-spacing: -0.02em;

  color: #000000;
}

.left-div-border {
  border-left: 4px solid;
  height: 35px;
  width: 4px;
  float: left;
}

</style>



// WEBPACK FOOTER //
// Pie.vue?14ee2288